<template>
  <div>
    <v-row class="align-center mt-2 ml-2">
      <!-- Checkbox -->
      <v-col cols="1">
        <v-checkbox
          :input-value="selected"
          @change="$emit('change', $event)"
          hide-details
        ></v-checkbox>
      </v-col>

      <!-- Imagen -->
      <v-col cols="2">
        <v-img
          @click.prevent="mostrarInfo(item)"
          src="require('@/assets/no-image.png')"
          aspect-ratio="1"
          class="rounded"
          style="cursor: pointer"
          contain
        ></v-img>
      </v-col>

      <!-- Descripción -->
      <v-col cols="2">
        <div class="font-weight-bold">#{{ item.codigoDeBarra }}</div>
        <div>
          <a
            @click.prevent="mostrarInfo(item)"
            class="white--text clickable-link"
          >
            {{ item.descripcion_comercial }}
          </a>
        </div>
        <div class="mt-1">
          <v-badge color="blue" dot>
            <span class="caption">{{
              item.categoria ? item.categoria.name : "Sin categoría"
            }}</span>
          </v-badge>
        </div>
        <div class="mt-1">
          <span class="caption grey--text">
            <strong>En stock:</strong> 10 unidad</span
          >
        </div>
      </v-col>

      <!-- Estadísticas -->
      <v-col cols="1"> </v-col>

      <!-- Precio y acciones -->
      <v-col cols="1" class="pa-1">
        <!-- Precio sugerido -->
        <div class="text-subtitle-1 font-weight-medium">
          {{ item.precio_venta_sugerido | convertPesoArg }}
        </div>
        <div class="caption grey--text">Incluye IVA</div>
        <v-btn
          small
          text
          color="primary"
          class="pa-0 mt-1"
          style="font-size: 11px; min-width: 0"
          @click.stop="mostrarInfo(item)"
        >
          Modificar
        </v-btn>
      </v-col>
      <v-col cols="2" class="pa-1">
        <!-- Precio sugerido -->

        <!-- Precio de costo -->
        <div class="mt-2 text-body-2">
          {{ item.precio_costo_base | convertPesoArg }}
        </div>
        <div class="caption grey--text">Precio de costo</div>

        <!-- Ganancia -->
        <div
          class="mt-2 text-body-2"
          :class="
            item.margen_ganancia_sugerido >= 0
              ? 'green--text text--darken-2'
              : 'red--text text--darken-2'
          "
        >
          {{ item.margen_ganancia_sugerido | convertPorcentaje }}
        </div>
        <div class="caption grey--text">Ganancia</div>
      </v-col>

      <v-col cols="3">
        <div>
          <span><strong>Sucursales asignadas</strong></span>
        </div>
        <div class="align-center justify-start flex-wrap">
          <v-chip
            v-for="(sucursal, index) in item.sucursales_compartidas.slice(0, 3)"
            :key="index"
            class="ma-1"
            small
          >
            {{ sucursal.sucursal.nombre }} (
            {{ sucursal.precio_venta | convertPesoArg }} )
          </v-chip>

          <v-btn
            v-if="item.sucursales_compartidas.length > 3"
            text
            small
            color="primary"
            class="ma-1"
            @click="abrirDialogSucursales(item)"
          >
            +{{ item.sucursales_compartidas.length - 2 }} más
          </v-btn>
        </div>
      </v-col>
      <v-dialog v-model="dialogSucursales.visible" max-width="500px">
        <v-card>
          <v-card-title class="headline"> Sucursales asignadas </v-card-title>
          <v-card-text>
            <v-list dense>
              <v-list-item
                v-for="(sucursal, index) in dialogSucursales.sucursales"
                :key="index"
              >
                <v-list-item-icon>
                  <v-icon color="primary">mdi-store</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{
                    sucursal.sucursal.nombre
                  }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>{{
                  sucursal.precio_venta | convertPesoArg
                }}</v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="dialogSucursales.visible = false"
            >
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-divider></v-divider>
  </div>
</template>
  
  <script>
export default {
  name: "ProductListItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogSucursales: {
        visible: false,
        sucursales: [],
      },
    };
  },
  computed: {
    precioFormateado() {
      return `$ ${Number(this.item.precio).toLocaleString("es-AR")}`;
    },
  },
  methods: {
    abrirDialogSucursales(item) {
      this.dialogSucursales.sucursales = item.sucursales_compartidas;
      this.dialogSucursales.visible = true;
    },
    mostrarInfo(producto) {
      // Aquí obtienes el uuid_empresa de la ruta actual
      const uuid_empresa = this.$route.params.uuid_empresa;

      // Rediriges al usuario a la ruta 'productoEmpresaDetalle' pasando los parámetros necesarios
      this.$router.push({
        name: "productoEmpresaDetalle",
        params: {
          uuid_empresa: uuid_empresa,
          id_producto: producto.id,
        },
      });
    },
    modificar() {
      window.open(this.item.url_modificar, "_blank");
    },
  },
};
</script>
  
  <style scoped>
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 250px;
}
</style>
  